(function () {
  function initTopPromoBanner(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    // ===== Top message carousel =====
    const track = root.querySelector('[data-track]');
    const slides = Array.from(root.querySelectorAll('.tpb__slide'));
    const dots = Array.from(root.querySelectorAll('[data-dot]'));
    const prevBtn = root.querySelector('.tpb__nav--prev');
    const nextBtn = root.querySelector('.tpb__nav--next');
    const dotsWrap = root.querySelector('[data-dots]');

    const toggleBtn = root.querySelector('[data-toggle]');
    const closeBtn = root.querySelector('[data-close]');
    const drawer = root.querySelector('.tpb__drawer');

    // ===== Drawer cards carousel =====
    const cardsViewport = root.querySelector('[data-cards-viewport]');
    const cardsTrack = root.querySelector('[data-cards-track]');
    const cardsPrev = root.querySelector('.tpb__cards-nav--prev');
    const cardsNext = root.querySelector('.tpb__cards-nav--next');
    const cardsDotsWrap = root.querySelector('[data-cards-dots]');
    const cardsDots = Array.from(root.querySelectorAll('[data-cards-dot]'));

    let current = 0;
    let autoPlay = null;
    let countdownTimer = null;
    let resizeRaf = null;

    let touchStartX = 0;
    let touchStartY = 0;
    let touchCurrentX = 0;
    let isSwipingCards = false;

    let topTouchStartX = 0;
    let topTouchStartY = 0;
    let topTouchCurrentX = 0;
    let isSwipingTop = false;

    const originalCards = cardsTrack
      ? Array.from(cardsTrack.children)
          .filter((el) => el.classList.contains('tpb__card'))
          .map((el) => el.cloneNode(true))
      : [];

    let cardCount = originalCards.length;
    let currentCardIndex = 0;
    let visibleCardsCount = 1;
    let renderIndex = 0;
    let cardStep = 0;
    let drawerBuilt = false;

    // =============================
    // Top bar message logic
    // =============================
    function getRotateSpeed() {
      const speed = Number(root.dataset.rotateSpeed || 4);
      return speed * 1000;
    }

    function goTo(index) {
      if (!track || !slides.length) return;

      current = (index + slides.length) % slides.length;
      track.style.transform = `translate3d(-${current * 100}%, 0, 0)`;

      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === current);
      });

      dots.forEach((dot, i) => {
        const isActive = i === current;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function updateTopNav() {
      const shouldHide = slides.length <= 1;

      if (prevBtn) {
        prevBtn.hidden = shouldHide;
        prevBtn.style.display = shouldHide ? 'none' : '';
      }

      if (nextBtn) {
        nextBtn.hidden = shouldHide;
        nextBtn.style.display = shouldHide ? 'none' : '';
      }

      if (dotsWrap) {
        dotsWrap.hidden = shouldHide;
        dotsWrap.style.display = shouldHide ? 'none' : '';
      }
    }

    function startAutoPlay() {
      if (root.dataset.autoRotate !== 'true' || slides.length < 2) return;

      stopAutoPlay();

      autoPlay = setInterval(function () {
        goTo(current + 1);
      }, getRotateSpeed());
    }

    function stopAutoPlay() {
      if (autoPlay) {
        clearInterval(autoPlay);
        autoPlay = null;
      }
    }

    // =============================
    // Drawer open / close
    // =============================
    function openDrawer() {
      if (!drawer || !toggleBtn) return;

      root.classList.add('is-open');
      drawer.hidden = false;
      toggleBtn.setAttribute('aria-expanded', 'true');

      requestAnimationFrame(function () {
        buildInfiniteTrack();
      });
    }

    function closeDrawer() {
      if (!drawer || !toggleBtn) return;

      root.classList.remove('is-open');
      drawer.hidden = true;
      toggleBtn.setAttribute('aria-expanded', 'false');
    }

    // =============================
    // Drawer cards infinite logic
    // =============================
    function getCardMetrics() {
      if (!cardsViewport || !cardsTrack || !cardsTrack.children.length) return null;

      const firstCard = cardsTrack.querySelector('.tpb__card');
      if (!firstCard) return null;

      const trackStyle = window.getComputedStyle(cardsTrack);
      const gap = parseFloat(trackStyle.gap || trackStyle.columnGap || 0) || 0;
      const cardWidth = firstCard.getBoundingClientRect().width;
      const step = cardWidth + gap;
      const viewportWidth = cardsViewport.clientWidth;
      const visibleCount =
        step > 0 ? Math.max(1, Math.floor((viewportWidth + gap) / step)) : 1;

      return {
        gap,
        cardWidth,
        step,
        viewportWidth,
        visibleCount
      };
    }

    function cloneCard(card) {
      return card.cloneNode(true);
    }

    function buildInfiniteTrack() {
      if (!cardsTrack || !cardsViewport || !cardCount) return;

      cardsTrack.innerHTML = '';

      originalCards.forEach((card) => {
        cardsTrack.appendChild(cloneCard(card));
      });

      const metrics = getCardMetrics();
      if (!metrics) return;

      visibleCardsCount = metrics.visibleCount;
      cardStep = metrics.step;

      const prependCards = [];
      const appendCards = [];

      for (let i = 0; i < visibleCardsCount; i += 1) {
        const prevIndex = (cardCount - visibleCardsCount + i + cardCount) % cardCount;
        const nextIndex = i % cardCount;

        prependCards.push(cloneCard(originalCards[prevIndex]));
        appendCards.push(cloneCard(originalCards[nextIndex]));
      }

      cardsTrack.innerHTML = '';

      prependCards.forEach((card) => cardsTrack.appendChild(card));
      originalCards.forEach((card) => cardsTrack.appendChild(cloneCard(card)));
      appendCards.forEach((card) => cardsTrack.appendChild(card));

      renderIndex = visibleCardsCount + currentCardIndex;
      drawerBuilt = true;

      applyCardTransform(false);
      updateDrawerDots();
      updateDrawerNav();
    }

    function applyCardTransform(animate) {
      if (!cardsTrack || !drawerBuilt) return;

      if (animate) {
        cardsTrack.style.transition = 'transform .35s ease';
      } else {
        cardsTrack.style.transition = 'none';
      }

      cardsTrack.style.transform = `translate3d(-${renderIndex * cardStep}px, 0, 0)`;

      if (!animate) {
        cardsTrack.offsetHeight;
        cardsTrack.style.transition = '';
      }
    }

    function updateDrawerDots() {
      if (!cardsDotsWrap) return;

      const shouldHide = cardCount <= 1;

      cardsDotsWrap.hidden = shouldHide;
      cardsDotsWrap.style.display = shouldHide ? 'none' : '';

      cardsDots.forEach((dot, i) => {
        const shouldShow = i < cardCount;
        const isActive = i === currentCardIndex;

        dot.style.display = shouldShow ? '' : 'none';
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    }

    function updateDrawerNav() {
      const shouldHide = cardCount <= 1;

      if (cardsPrev) {
        cardsPrev.style.visibility = shouldHide ? 'hidden' : 'visible';
        cardsPrev.style.opacity = shouldHide ? '0' : '1';
        cardsPrev.style.pointerEvents = shouldHide ? 'none' : 'auto';
        cardsPrev.disabled = shouldHide;
      }

      if (cardsNext) {
        cardsNext.style.visibility = shouldHide ? 'hidden' : 'visible';
        cardsNext.style.opacity = shouldHide ? '0' : '1';
        cardsNext.style.pointerEvents = shouldHide ? 'none' : 'auto';
        cardsNext.disabled = shouldHide;
      }
    }

    function syncLoopPositionIfNeeded() {
      if (!drawerBuilt || !cardCount) return;

      const minIndex = visibleCardsCount;
      const maxIndex = visibleCardsCount + cardCount - 1;

      if (renderIndex < minIndex) {
        renderIndex = visibleCardsCount + currentCardIndex;
        applyCardTransform(false);
      }

      if (renderIndex > maxIndex) {
        renderIndex = visibleCardsCount + currentCardIndex;
        applyCardTransform(false);
      }
    }

    function goToPrevCard() {
      if (cardCount <= 1) return;

      currentCardIndex = (currentCardIndex - 1 + cardCount) % cardCount;
      renderIndex -= 1;

      applyCardTransform(true);
      updateDrawerDots();
      updateDrawerNav();
    }

    function goToNextCard() {
      if (cardCount <= 1) return;

      currentCardIndex = (currentCardIndex + 1) % cardCount;
      renderIndex += 1;

      applyCardTransform(true);
      updateDrawerDots();
      updateDrawerNav();
    }

    function goToCard(index) {
      if (cardCount <= 1) return;

      const target = Math.max(0, Math.min(index, cardCount - 1));

      currentCardIndex = target;
      renderIndex = visibleCardsCount + currentCardIndex;

      applyCardTransform(true);
      updateDrawerDots();
      updateDrawerNav();
    }

    // =============================
    // Countdown
    // =============================
    function formatUnit(value) {
      return String(value).padStart(2, '0');
    }

    function parseCountdownDate(input) {
      if (!input) return null;

      const raw = String(input).trim();

      // 1. Try original value first.
      let date = new Date(raw);
      if (!Number.isNaN(date.getTime())) return date;

      // 2. Convert "2026-04-20 10:00:00" to "2026-04-20T10:00:00".
      const normalized = raw.replace(' ', 'T');
      date = new Date(normalized);
      if (!Number.isNaN(date.getTime())) return date;

      // 3. Manual parsing for stricter browsers.
      const match = raw.match(
        /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/
      );

      if (!match) return null;

      const [, y, m, d, hh = '00', mm = '00', ss = '00'] = match;

      date = new Date(
        Number(y),
        Number(m) - 1,
        Number(d),
        Number(hh),
        Number(mm),
        Number(ss)
      );

      return Number.isNaN(date.getTime()) ? null : date;
    }

    function initCountdowns() {
      const countdownEls = Array.from(root.querySelectorAll('[data-countdown]'));
      if (!countdownEls.length) return;

      function tick() {
        const now = Date.now();

        countdownEls.forEach(function (el) {
          const endRaw = el.dataset.end;
          if (!endRaw) return;

          const endDate = parseCountdownDate(endRaw);

          if (!endDate) {
            console.warn('Invalid countdown date:', endRaw);
            return;
          }

          const end = endDate.getTime();
          const distance = end - now;
          const endAction = el.dataset.endAction || 'message';

          const groupEl = el.closest('[data-countdown-group]');
          const prefixEl = el.querySelector('.tpb__countdown-prefix');
          const endedEl = el.querySelector('.tpb__countdown-ended');
          const timeWrapEl = el.querySelector('.tpb__countdown-time');

          const ddEl = el.querySelector('[data-role="dd"]');
          const hhEl = el.querySelector('[data-role="hh"]');
          const mmEl = el.querySelector('[data-role="mm"]');
          const ssEl = el.querySelector('[data-role="ss"]');

          const separator = el.dataset.separator || ':';
          const separators = el.querySelectorAll('.tpb__countdown-separator');

          separators.forEach(function (sep) {
            sep.textContent = separator;
          });

          if (distance <= 0) {
            if (prefixEl) prefixEl.textContent = '';

            if (endAction === 'hide') {
              if (groupEl) {
                groupEl.hidden = true;
                groupEl.style.display = 'none';
              } else {
                el.hidden = true;
                el.style.display = 'none';
              }

              return;
            }

            if (timeWrapEl) timeWrapEl.hidden = true;

            if (endedEl) {
              endedEl.hidden = false;
              endedEl.textContent = el.dataset.expired || 'Ended';
            }

            return;
          }

          // Reset display while countdown is still active.
          if (groupEl) {
            groupEl.hidden = false;
            groupEl.style.display = '';
          }

          el.hidden = false;
          el.style.display = '';

          if (timeWrapEl) timeWrapEl.hidden = false;
          if (endedEl) endedEl.hidden = true;

          const totalSeconds = Math.floor(distance / 1000);
          const days = Math.floor(totalSeconds / 86400);
          const hours = Math.floor((totalSeconds % 86400) / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;

          if (ddEl) ddEl.textContent = formatUnit(days);
          if (hhEl) hhEl.textContent = formatUnit(hours);
          if (mmEl) mmEl.textContent = formatUnit(minutes);
          if (ssEl) ssEl.textContent = formatUnit(seconds);
        });
      }

      tick();
      countdownTimer = setInterval(tick, 1000);
    }

    // =============================
    // Resize
    // =============================
    function onResize() {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);

      resizeRaf = requestAnimationFrame(function () {
        updateTopNav();

        if (drawer && !drawer.hidden) {
          buildInfiniteTrack();
        }
      });
    }

    function bindTopSwipe() {
      const topViewport = root.querySelector('.tpb__viewport');
      if (!topViewport) return;

      const swipeThreshold = 40;
      const verticalLockThreshold = 24;

      topViewport.addEventListener(
        'touchstart',
        function (event) {
          if (!event.touches || event.touches.length !== 1) return;
          if (slides.length <= 1) return;

          topTouchStartX = event.touches[0].clientX;
          topTouchStartY = event.touches[0].clientY;
          topTouchCurrentX = topTouchStartX;
          isSwipingTop = false;
        },
        { passive: true }
      );

      topViewport.addEventListener(
        'touchmove',
        function (event) {
          if (!event.touches || event.touches.length !== 1) return;
          if (slides.length <= 1) return;

          topTouchCurrentX = event.touches[0].clientX;
          const currentY = event.touches[0].clientY;

          const deltaX = topTouchCurrentX - topTouchStartX;
          const deltaY = currentY - topTouchStartY;

          if (Math.abs(deltaX) > verticalLockThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
            isSwipingTop = true;
          }
        },
        { passive: true }
      );

      topViewport.addEventListener(
        'touchend',
        function () {
          if (slides.length <= 1) return;

          const deltaX = topTouchCurrentX - topTouchStartX;

          if (!isSwipingTop) return;

          if (Math.abs(deltaX) >= swipeThreshold) {
            if (deltaX < 0) {
              goTo(current + 1);
            } else {
              goTo(current - 1);
            }

            startAutoPlay();
          }

          topTouchStartX = 0;
          topTouchStartY = 0;
          topTouchCurrentX = 0;
          isSwipingTop = false;
        },
        { passive: true }
      );
    }

    function bindTouchSwipe() {
      if (!cardsViewport) return;

      const swipeThreshold = 40;
      const verticalLockThreshold = 24;

      cardsViewport.addEventListener(
        'touchstart',
        function (event) {
          if (!drawer || drawer.hidden) return;
          if (!event.touches || event.touches.length !== 1) return;

          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
          touchCurrentX = touchStartX;
          isSwipingCards = false;
        },
        { passive: true }
      );

      cardsViewport.addEventListener(
        'touchmove',
        function (event) {
          if (!drawer || drawer.hidden) return;
          if (!event.touches || event.touches.length !== 1) return;

          touchCurrentX = event.touches[0].clientX;
          const currentY = event.touches[0].clientY;

          const deltaX = touchCurrentX - touchStartX;
          const deltaY = currentY - touchStartY;

          if (Math.abs(deltaX) > verticalLockThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
            isSwipingCards = true;
          }
        },
        { passive: true }
      );

      cardsViewport.addEventListener(
        'touchend',
        function () {
          if (!drawer || drawer.hidden) return;

          const deltaX = touchCurrentX - touchStartX;

          if (!isSwipingCards) return;

          if (Math.abs(deltaX) >= swipeThreshold) {
            if (deltaX < 0) {
              goToNextCard();
            } else {
              goToPrevCard();
            }
          }

          touchStartX = 0;
          touchStartY = 0;
          touchCurrentX = 0;
          isSwipingCards = false;
        },
        { passive: true }
      );
    }

    // =============================
    // Events
    // =============================
    function bindEvents() {
      // Top messages
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(current - 1);
          startAutoPlay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(current + 1);
          startAutoPlay();
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(Number(dot.dataset.dot));
          startAutoPlay();
        });
      });

      // Drawer toggle
      if (toggleBtn) {
        toggleBtn.addEventListener('click', function () {
          if (root.classList.contains('is-open')) {
            closeDrawer();
          } else {
            openDrawer();
          }
        });
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', closeDrawer);
      }

      // Drawer arrows
      if (cardsPrev) {
        cardsPrev.addEventListener('click', goToPrevCard);
      }

      if (cardsNext) {
        cardsNext.addEventListener('click', goToNextCard);
      }

      // Drawer dots
      cardsDots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          const nextIndex = Number(dot.dataset.cardsDot) || 0;
          goToCard(nextIndex);
        });
      });

      // Infinite reset after animation
      if (cardsTrack) {
        cardsTrack.addEventListener('transitionend', function () {
          syncLoopPositionIfNeeded();
        });
      }

      root.addEventListener('mouseenter', stopAutoPlay);
      root.addEventListener('mouseleave', startAutoPlay);
      window.addEventListener('resize', onResize);

      bindTopSwipe();
      bindTouchSwipe();
    }

    // =============================
    // Init
    // =============================
    goTo(0);
    updateTopNav();
    bindEvents();
    startAutoPlay();
    initCountdowns();

    root._tpbDestroy = function () {
      stopAutoPlay();

      if (countdownTimer) clearInterval(countdownTimer);
      if (resizeRaf) cancelAnimationFrame(resizeRaf);

      window.removeEventListener('resize', onResize);
    };
  }

  function initAllTopPromoBanners(scope) {
    const container = scope || document;
    const banners = container.querySelectorAll('.top-promo-banner');

    banners.forEach(function (banner) {
      initTopPromoBanner(banner);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllTopPromoBanners(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllTopPromoBanners(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const banners = event.target.querySelectorAll('.top-promo-banner');

    banners.forEach(function (banner) {
      if (typeof banner._tpbDestroy === 'function') {
        banner._tpbDestroy();
      }
    });
  });
})();